// The table footer pager — brief §4.5 (P25, P31), 2026-09-24:
//
//   [ Previous ]  ( 1  2  [3]  4 )  [ Next ]
//
// - The pages are a CHOICE control, so they ARE the brand `TabSet`: the
//   `widgetPlate` capsule track, transparent chips, and the chosen page as
//   the full inversion — `highlight` fill + `highlight-reversed` ink (D-1).
//   The default-library `Pagination` these apps do not link (their registry
//   has no such component), so it could not be the base.
// - Previous and Next are TEXT buttons: the quiet `tertiary` control (brief
//   K2), disabled at the ends — `disabled` ink, no fill, never opacity.
//
// State contract (read from the element's state, like any DOMQL collection):
//   s.page       the current page, 1-based
//   s.pageCount  how many pages
// A click writes `s.page`; the owner reacts to it (e.g. `fetch: { page:
// (el, s) => s.page }`). The chosen chip also carries aria-current="page".
export const AppPagination = {
  tag: 'nav',
  ariaLabel: (el) => el.call('polyglot', 'common.pagination.label'),
  flow: 'x',
  align: 'center',
  gap: 'Z',

  AppPaginationPrevious: {},

  TabSet: {
    // A WINDOW of pages, never one chip per page of a long list: the first,
    // the last, and the current page with two on each side (at most 7 — see
    // functions/appPageWindow.js). Keyed by page number, so a window that
    // shifts keeps the chips it shares.
    children: (el, s) =>
      el.call('appPageWindow', s.page, s.pageCount).map((page) => ({
        key: `page-${page}`,
        page,
        text: String(page)
      })),
    childProps: {
      isActive: (el, s) => el.page === (s.page || 1),
      ariaCurrent: (el, s) => (el.page === (s.page || 1) ? 'page' : null),
      onClick: (e, el, s) => s.update({ page: el.page })
    }
  },

  AppPaginationNext: {}
}

// Previous / Next share one text-button scale and one disabled look.
export const AppPaginationStep = {
  extends: 'Button',
  theme: 'tertiary',
  ':disabled': {
    color: 'disabled',
    background: 'transparent',
    cursor: 'not-allowed',
    pointerEvents: 'none'
  }
}

export const AppPaginationPrevious = {
  extends: 'AppPaginationStep',
  text: '{{ common.action.previous | polyglot }}',
  disabled: (el, s) => (s.page || 1) <= 1,
  onClick: (e, el, s) => {
    if ((s.page || 1) > 1) s.update({ page: (s.page || 1) - 1 })
  }
}

export const AppPaginationNext = {
  extends: 'AppPaginationStep',
  text: '{{ common.action.next | polyglot }}',
  disabled: (el, s) => (s.page || 1) >= (s.pageCount || 1),
  onClick: (e, el, s) => {
    if ((s.page || 1) < (s.pageCount || 1)) s.update({ page: (s.page || 1) + 1 })
  }
}
